import React from 'react';
import DokumentasjonsDropdown from '../../dokumentasjonsDropdown';
import { Image } from 'react-bootstrap';
import dekkomlegger from '../../../images/Lakkeringskabin.jpg';

function Dokumentasjon() {

    return(
        <div className="mb-5">
            {/* <h1 className="mt-5">DOKUMENTASJON</h1> */}

            <div className="container">
                <div className="row mt-2 d-flex justify-content-center align-items-center">
                    <div className="col-4 ms-5">
                        <div className="col-8">
                            <Image src={dekkomlegger} alt="name"fluid/>
                        </div>
                    </div>
                    <div className="col-6">
                        <h2 className="bold-h2">Chronotech HE Lakkeringskabin</h2>
                        <h3 className="mt-5 underline">fra USI Italia</h3>
                    </div>
                </div>
                <div className="row d-flex mt-3 col-12">
                    <div className="col m-auto">
                        <h1>DOKUMENTASJON</h1>
                        <DokumentasjonsDropdown />
                    </div>
                    <div className="col-7 m-auto">
                        <p className="bold">Serienummer:10638C02</p>
                        <p className="bold">Neste planlagte service: 10/04/24</p>
                        <p className="bold">Service sist utført: 10/04/23</p>
                        <p className="bold">Bestilt: 10/04/23</p>
                        <p className="bold">Levert: 10/05/23</p>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Dokumentasjon;